<template>
  <div class="stop-list-menu-item" :class="{'food-card__with-stop': hasStop}">
    <!--    <div class="badge-left d-flex flex-column align-center">
      <component :is="getLeftSticker"/>
      <icon-doubling v-if="isDoubling"/>
    </div>

    <div class="badge-right d-flex flex-column align-center">
      <component :is="getRightSticker"/>
    </div>-->

    <div class="card-image d-flex align-center justify-center">
      <img v-if="item.image" :src="item.image" alt="Food" />
      <font-awesome-icon v-if="!item.image" icon="utensils" />

      <div v-if="hasStop" class="food-card_stop">
        <!--        <icon-stop/> -->На стопе
      </div>
    </div>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          class="footer"
          v-on="on"
          @click="emitEvents"
        >
          <div class="d-flex align-center justify-space-between footer_inner">
            <div class="card-info">
              <span class="title font-weight-regular">{{ item.name }}</span>
              <span class="price font-weight-medium">{{ item.price | amountStringWithCurrency }}</span>
            </div>
            <v-btn
              v-if="hasStop"
              class="button-action button-action__remove"
              color="#ff9100"
              dark
              circle
              fab
              depressed
            >
              <icon-kitchen />
            </v-btn>
            <v-btn
              v-else
              class="button-action"
              color="#ff005f"
              dark
              circle
              fab
              depressed
            >
              <icon-stop />
            </v-btn>
          </div>
        </div>
      </template>
      <template v-if="hasStop">
        Удалить из стоп-листа
      </template>
      <template v-else>
        Добавить в стоп-лист
      </template>
    </v-tooltip>
  </div>
</template>

<script>
  import mixinGetFoodStickers from '@/mixins/get-food-stickers'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import IconDoubling from '@/components/order-processing/order-components/icons/IconDoubling'
  import IconStop from '@/components/aside/icons/IconStop.vue'
  import IconKitchen from '@/components/aside/icons/IconKitchen.vue'

  export default {
    name: 'StopListMenuItem',
    components: { IconKitchen, IconStop, IconDoubling },
    mixins: [mixinGetFoodStickers, mixinSnackbarMessage],
    emits: [
      'addToStopList',
      'removeFromStopList',
    ],
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      hasStop () {
        return this.item.hasStop
      },
      getItemPrice () {
        return this.item.price ? this.item.price + ' ₽' : '0 ₽'
      },
      hasBonus () {
        return this.item.foxCoinsAdd
      },
      isDoubling () {
        return this.item && this.item.isDoubling
      },
    },
    methods: {
      emitEvents () {
        if (!this.hasStop) {
          this.$emit('addToStopList', this.item.id)
        } else {
          this.$emit('removeFromStopList', this.item.id)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.stop-list-menu-item {
  position: relative;
  background-color: #ffffff;
  border-radius: 10px;
  //box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  box-shadow: 0 3px 6px #00000029;
  overflow: hidden;
  //padding-top: 10px;
  z-index: 0;
  font-size: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;

  .media-xl({
    font-size: 14px;
  });

  .badge-left {
    position: absolute;
    top: 15px;
    left: 8px;

    svg {
      margin-bottom: 10px;
    }

    .fox-coins {
      svg {
        margin-bottom: 0;
      }

      span {
        color: #ff9100;
        font-size: 1em;
        font-weight: bold;
      }
    }
  }

  .badge-right {
    position: absolute;
    top: 15px;
    right: 26px;

    svg {
      margin-bottom: 10px;
    }
  }

  .card-image {
    width: 100%;
    height: 182px;
    text-align: center;
    cursor: pointer;
    object-fit: contain;
    background-color: @menu-item-image-bg;

    svg {
      width: 70px;
      height: 70px;
      opacity: 0.4;
      .fill-svg(@color-primary);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

  }

  .footer {
    padding: 11px 20px 15px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    flex-grow: 1;
    display: flex;
    align-items: center;

    &:hover {
      background-color: #ffddac;
    }

    &_inner {
      flex-grow: 1;
    }

    .card-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title,
      .price {
        display: block;
      }

      .title {
        font-size: 1em !important;
        font-weight: 500 !important;
        line-height: 1;
        margin-bottom: 6px;
        min-height: 2em;

        // уже 1300px карточек три в ряд, и название крупнее
        @media (max-width: 1299px) {
          font-size: 15px !important;
          line-height: 1.15;
        }
      }

      .price {
        font-size: 1.5em;
        line-height: 1.2;
      }
    }

    .button-action {
      margin-left: 28px;
      width: 40px;
      height: 40px;

      svg {
        width: 20px;
        height: 20px;
      }

      &__remove {
        svg {
          color: #fff;
          path {
            fill: #ffffff !important;
          }
        }
      }
    }

    .media-sm({
      padding-left: 5px;
      padding-right: 5px;
    });

  }

  &.food-card__with-stop {
    .card-image {
      position: relative;

      img {
        opacity: 0.5;
        filter: blur(1px);
      }
      .food-card_stop {
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 10px;
        position: absolute;
        top: 50%;
        left: 50%;
        background: #ff005f;
        color: #fff;
        font-size: 14px;
        text-transform: uppercase;
        font-weight: bold;
        white-space: nowrap;
        transform: translate(-50%, -50%);
        svg {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          color: #fff;
          path {
            fill: #ffffff !important;
          }
        }
      }
    }

  }

}
</style>
